var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./WaitingForDeliveryGetEditPage.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-8408b200!../../node_modules/vue-loader/lib/selector?type=template&index=0!./WaitingForDeliveryGetEditPage.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/WaitingForDeliveryGetEditPage.vue
// module id = 311
// module chunks = 1